import { createAction } from 'redux-actions-helpers'
import { AchievementItemType } from './types'
import { CourseType, ProgressType } from '../CoursePage/types'

export const fetchUserState = createAction(
  '@@achievements-page/FETCH_USER_STATE',
  (id: string): any => ({ id })
)

export const fetchUserStateSuccess = createAction(
  '@@achievements-page/FETCH_USER_STATE_SUCCESS',
  (result: ProgressType): any => ({ result })
)

export const fetchUserStateFailure = createAction(
  '@@achievements-page/FETCH_USER_STATE_FAILURE',
  (error: string): any => ({ error })
)

export const fetchAchievements = createAction(
  '@@achievements-page/FETCH_ACHIEVEMENTS'
)

export const fetchAchievementsSuccess = createAction(
  '@@achievements-page/FETCH_ACHIEVEMENTS_SUCCESS',
  (result: AchievementItemType[]): any => ({ result })
)

export const fetchAchievementsFailure = createAction(
  '@@achievements-page/FETCH_ACHIEVEMENTS_FAILURE',
  (error: string): any => ({ error })
)

export const fetchCoursesList = createAction(
  '@@achievements-page/FETCH_COURSES_LIST'
)

export const fetchCoursesListSuccess = createAction(
  '@@achievements-page/FETCH_COURSES_LIST_SUCCESS',
  (result: CourseType[]): any => ({ result })
)

export const fetchCoursesListFailure = createAction(
  '@@achievements-page/FETCH_COURSES_LIST_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@achievements-page/DESTROY')
